import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditarAtoComponent } from './components/editar-ato/editar-ato.component';
import { GerirAtosComponent } from './components/gerir-atos/gerir-atos.component';
import { VisualizarAtoComponent } from './components/visualizar-ato/visualizar-ato.component';
import { ImprimirAtoComponent } from './components/imprimir-ato/imprimir-ato.component';

const routes: Routes = [
    {
        path: '',
        children: [

            // *** Visualização do Ato pelo Gerir Atos -> Acesso INTRANET, com login e com cabeçalho 'Normas Administração'
            {
                path: 'visualizar-ato/:id',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'visualizar-ato/:id/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'visualizar-ato/:id/visao/:visao',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'visualizar-ato/:id/visao/:visao/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'visualizar-ato/:id/data/:ano/:mes/:dia',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'visualizar-ato/:id/data/:ano/:mes/:dia/vs/:vs',
                component: VisualizarAtoComponent,
                data: {
                    gerirAto: true,
                    breadcrumb: 'Visualizar ato',
                },
            },
            {
                path: 'gerir-atos',
                component: GerirAtosComponent,
                data: {
                    breadcrumb: 'Gerir atos',
                },
            },
            {
                path: 'incluir-ato',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Incluir ato',
                },
            },
            {
                path: 'incluir-por-curadoria/:id',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Incluir ato por curadoria',
                },
            },
            {
                path: 'incluir-por-duplicacao/:id',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Duplicar ato',
                },
            },
            {
                path: 'corrigir-ato/:id',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Corrigir ato',
                },
            },
            {
                path: 'republicar-ato/:id',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Republicar ato',
                },
            },
            {
                path: 'republicar-comparacao',
                component: EditarAtoComponent,
                data: {
                    breadcrumb: 'Republicar ato',
                },
            },
            {
                path: 'visualizar-ato/imprimir/:id/visao/:visao',
                component: ImprimirAtoComponent,
                data: {
                    breadcrumb: 'Imprimir ato',
                },
            },
            {
                path: 'visualizar-ato/imprimir/:id/data/:ano/:mes/:dia',
                component: ImprimirAtoComponent,
                data: {
                    breadcrumb: 'Imprimir ato',
                },
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AtosRoutingModule { }
